import React, { Component } from "react";
import { withRouter } from "react-router";
import { Row, Col, Button, Input, Form, Table, Spin, message } from "antd";
import AppConfigs from "../../Config/AppConfig";
import { add, list } from "../../api/Apis";
// import ResizableAntdTable from "resizable-antd-table";

const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends React.Component {
  state = {
    editing: true,
  };

  toggleEdit = () => {
    const editing = !this.state.editing;
    this.setState({ editing }, () => {
      if (editing) {
        this.input.focus();
      }
    });
  };

  save = (e) => {
    const { record, handleSave } = this.props;
    this.form.validateFields((error, values) => {
      if (error && error[e.currentTarget.id]) {
        return;
      }
      //   this.toggleEdit();
      handleSave({ ...record, ...values });
    });
  };

  renderCell = (form) => {
    this.form = form;
    const { children, dataIndex, record, title } = this.props;
    const { editing } = this.state;
    return editing && record["size"] ? (
      <Form.Item style={{ margin: 0 }}>
        {form.getFieldDecorator(dataIndex, {
          rules: [
            {
              required: true,
              message: `${title} is required.`,
            },
          ],
          initialValue: record[dataIndex],
        })(
          <Input
            ref={(node) => (this.input = node)}
            onPressEnter={this.save}
            onBlur={this.save}
            style={{ width: "50px" }}
          />
        )}
      </Form.Item>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{ paddingRight: 24 }}
        onClick={this.toggleEdit}
      >
        {children}
      </div>
    );
  };

  render() {
    const {
      editable,
      dataIndex,
      title,
      record,
      index,
      handleSave,
      children,
      ...restProps
    } = this.props;
    return (
      <td {...restProps}>
        {editable ? (
          <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
        ) : (
          children
        )}
      </td>
    );
  }
}

class PriceQuoteTool extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      products: [],
      priceQuoteToolData: [],
      pageLoading: true,
      milesData: [
        {
          min: 0,
          max: 11,
          key: "0_11",
        },
        {
          min: 11,
          max: 26,
          key: "11_26",
        },
        {
          min: 26,
          max: 43,
          key: "26_43",
        },
        {
          min: 43,
          max: 63,
          key: "43_63",
        },

        {
          min: 63,
          max: 92,
          key: "63_92",
        },
        {
          min: 92,
          max: 134,
          key: "92_134",
        },
        {
          min: 134,
          max: 195,
          key: "134_195",
        },
        {
          min: 195,
          max: 283,
          key: "195_283",
        },
        {
          min: 283,
          max: 411,
          key: "283_411",
        },
        {
          min: 411,
          max: 596,
          key: "411_596",
        },
        {
          min: 596,
          max: 863,
          key: "596_863",
        },
        {
          min: 863,
          max: 1251,
          key: "863_1251",
        },
        {
          min: 1251,
          max: 1814,
          key: "1251_1814",
        },
      ],
    };
  }
  componentDidMount() {
    this.getPriceQuoteToolData();
  }
  getPriceQuoteToolData = () => {
    let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    list(AppConfigs["entityNames"]["products"]).then((result) => {
      if (result.success) {
        list(AppConfigs["entityNames"]["priceQuoteToolData"]).then(
          (priceResult) => {
            if (priceResult.success) {
              let productsData = result.data.filter((item) => !item["linkId"]);
              let priceQuoteToolData = [];
              productsData.map((product) => {
                let children = [];
                let productOrigin = orgDetails["yardLocations"].filter(
                  (loc) => loc.id === product["productOrigin"][0]
                );
                let productOriginLatLng =
                  productOrigin.length > 0 ? productOrigin[0]["latLng"] : {};
                product.sizes.map((size) => {
                  children.push({
                    productId: product["id"],
                    key: product["id"] + size["size"],
                    size: size["size"],
                    cost: 0,
                    margin: 0,
                    "0_11": 0,
                    "11_26": 0,
                    "26_43": 0,
                    "43_63": 0,
                    "63_92": 0,
                    "92_134": 0,
                    "134_195": 0,
                    "195_283": 0,
                    "283_411": 0,
                    "411_596": 0,
                    "596_863": 0,
                    "863_1251": 0,
                    "1251_1814": 0,
                  });
                  return size;
                });
                priceQuoteToolData.push({
                  key: product["id"],
                  product: product.productName,
                  productCode: product.productCode,
                  image: product.images[0],
                  productOriginLatLng: productOriginLatLng,
                  children: children,
                });
                return product;
              });
              priceQuoteToolData.map((product, index) => {
                let childIndex = priceResult.data.findIndex(
                  (item) => product.key === item.productId
                );
                if (childIndex > -1) {
                  this.props.form.setFieldsValue({
                    validTo: priceResult.data[childIndex].validTo,
                  });
                  product["id"] = priceResult.data[childIndex]["id"];
                  product.children.map((size) => {
                    let sizeIndex = priceResult.data[childIndex][
                      "sizes"
                    ].findIndex((item) => size["size"] === item.size);
                    size["cost"] =
                      sizeIndex > -1
                        ? priceResult.data[childIndex]["sizes"][sizeIndex][
                            "cost"
                          ]
                        : 0;
                    size["margin"] =
                      sizeIndex > -1
                        ? priceResult.data[childIndex]["sizes"][sizeIndex][
                            "margin"
                          ]
                        : 0;
                    if (sizeIndex > -1) {
                      priceResult.data[childIndex]["sizes"][sizeIndex][
                        "milePrices"
                      ].map((mile) => {
                        size[mile["minValues"] + "_" + mile["maxValues"]] =
                          mile["value"];
                        return mile;
                      });
                    } else {
                      size["0_11"] = 0;
                      size["11_26"] = 0;
                      size["26_43"] = 0;
                      size["43_63"] = 0;
                      size["63_92"] = 0;
                      size["92_134"] = 0;
                      size["134_195"] = 0;
                      size["195_283"] = 0;
                      size["283_411"] = 0;
                      size["411_596"] = 0;
                      size["596_863"] = 0;
                      size["863_1251"] = 0;
                      size["1251_1814"] = 0;
                    }
                    return size;
                  });
                }
                return product;
              });
              this.setState({
                priceQuoteToolData,
                pageLoading: false,
              });
            }
          }
        );
      } else {
        this.setState({
          pageLoading: false,
        });
        console.log(result.errors);
      }
    });
  };

  handleSave = (row) => {
    const newData = [...this.state.priceQuoteToolData];
    const index = newData.findIndex((item) => row.productId === item.key);
    const childIndex = newData[index]["children"].findIndex(
      (item) => row.key === item.key
    );
    const child = newData[index]["children"][childIndex];
    newData[index]["children"].splice(childIndex, 1, {
      ...child,
      ...row,
    });
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...newData[index],
    });
    this.setState({ priceQuoteToolData: newData });
  };

  handleSubmit = (e) => {
    let priceQuoteToolData = [];
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        this.setState({
          pageLoading: true,
        });
        this.state.priceQuoteToolData.map((price) => {
          let sizes = [];
          price["children"].map((size) => {
            let milePrices = [];
            this.state.milesData.map((mile) => {
              milePrices.push({
                minValues: mile["min"],
                maxValues: mile["max"],
                value: size[mile["key"]],
              });
              return mile;
            });
            sizes.push({
              size: size["size"],
              cost: size["cost"],
              margin: size["margin"],
              milePrices: milePrices,
            });
            return size;
          });
          if ("id" in price) {
            priceQuoteToolData.push({
              productName: price["product"],
              productCode: price.productCode,
              image: price.image,
              productId: price["key"],
              productOrigin: price["productOriginLatLng"],
              sizes: sizes,
              validTo: values["validTo"],
              id: price["id"],
            });
          } else {
            priceQuoteToolData.push({
              productName: price["product"],
              productCode: price.productCode,
              image: price.image,
              productId: price["key"],
              productOrigin: price["productOriginLatLng"],
              sizes: sizes,
              validTo: values["validTo"],
            });
          }
          return price;
        });
        priceQuoteToolData.map((quote, index) => {
          let data = {};
          data["entityData"] = quote;
          add(AppConfigs["entityNames"]["priceQuoteToolData"], data).then(
            (result) => {
              if (result.success) {
                if (priceQuoteToolData.length === index + 1) {
                  message.success("Data save successfully");
                  this.getPriceQuoteToolData();
                  // this.props.history.push('/app/loads');
                }
              } else {
                console.log(result.errors);
              }
            }
          );
          return quote;
        });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const columns = [
      {
        title: "Product",
        dataIndex: "product",
        key: "product",
        width:150
      },
      {
        title: "Size",
        dataIndex: "size",
        key: "size",
      },
      {
        title: "Cost",
        dataIndex: "cost",
        key: "cost",
        editable: true,
      },
      {
        title: "Margin",
        dataIndex: "margin",
        key: "margin",
        editable: true,
      },
      {
        title: "0-10.99",
        dataIndex: "0_11",
        key: "0_11",
        editable: true,
      },
      {
        title: "11-25.99",
        dataIndex: "11_26",
        key: "11_26",
        editable: true,
      },
      {
        title: "26-42.99",
        dataIndex: "26_43",
        key: "26_43",
        editable: true,
      },
      {
        title: "43-62.99",
        dataIndex: "43_63",
        key: "43_63",
        editable: true,
      },
      {
        title: "63-91.99",
        dataIndex: "63_92",
        key: "63_92",
        editable: true,
      },
      {
        title: "92-133.99",
        dataIndex: "92_134",
        key: "92_134",
        editable: true,
      },
      {
        title: "134-194.99",
        dataIndex: "134_195",
        key: "134_195",
        editable: true,
      },
      {
        title: "195-282.99",
        dataIndex: "195_283",
        key: "195_283",
        editable: true,
      },
      {
        title: "283-410.99",
        dataIndex: "283_411",
        key: "283_411",
        editable: true,
      },
      {
        title: "411-595.99",
        dataIndex: "411_596",
        key: "411_596",
        editable: true,
      },
      {
        title: "596-862.99",
        dataIndex: "596_863",
        key: "596_863",
        editable: true,
      },
      {
        title: "863-1250.99",
        dataIndex: "863_1251",
        key: "863_1251",
        editable: true,
      },
      {
        title: "1251-1813.99",
        dataIndex: "1251_1814",
        key: "1251_1814",
        editable: true,
      },
    ];

    const components = {
      body: {
        row: EditableFormRow,
        cell: EditableCell,
      },
    };
    const column = columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: (record) => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave: this.handleSave,
        }),
      };
    });
    return (
      <div>
        <Spin spinning={this.state.pageLoading}>
          <Row gutter={10} style={{ margin: "40px 20px" }}>
            <div>
              <Col lg={2} md={2} sm={24} xs={24}>
                <Form.Item
                  className="Formitem"
                  label={
                    <span style={{ color: "#7B8190", fontSize: "14px" }} flex>
                      Valid To
                    </span>
                  }
                />
              </Col>
              <Col
                lg={12}
                md={12}
                sm={24}
                xs={24}
                style={{ marginBottom: "10px" }}
              >
                <Form>
                  <Form.Item
                    className="Formitem"
                    // label={<span style={{ color: '#7B8190', fontSize: '14px' }} flex>Valid To:</span>}
                  >
                    {getFieldDecorator("validTo", {
                      rules: [
                        { required: true, message: "Please select valid to" },
                      ],
                    })(<Input type="date" placeholder="Valid To" />)}
                  </Form.Item>
                </Form>
              </Col>
              <Col
                lg={10}
                md={12}
                sm={24}
                xs={24}
                style={{ marginBottom: "10px" }}
              >
                <Button
                  type="primary"
                  htmlType="submit"
                  onClick={this.handleSubmit}
                  style={{
                    float: "right",
                    backgroundColor: "#255595",
                    color: "white",
                    marginRight: "30px",
                    padding: "0 20px 0 20px",
                  }}
                >
                  Save
                </Button>
              </Col>
              <Col
                lg={24}
                md={24}
                sm={24}
                xs={24}
                style={{ marginBottom: "10px" }}
              >
                <Table
                  bordered={true}
                  components={components}
                  rowClassName={() => "editable-row"}
                  columns={column}
                  pagination={false}
                  dataSource={this.state.priceQuoteToolData}
                  scroll={{
                    x: 1300,
                    y:400
                  }}
                />
              </Col>
            </div>
          </Row>
        </Spin>
      </div>
    );
  }
}

export default Form.create({ name: "PriceQuoteTool" })(
  withRouter(PriceQuoteTool)
);
